import backend from '@common/backend';

const BASE = '/goals';

export const postGoal = async (data: any) => backend.post(`${BASE}`, data);

export const saveGoal = async (id: number, data: any) => backend
	.patch(`${BASE}/${id}`, data);

export const deleteGoal = async (id: number) => backend.delete(`${BASE}/${id}`);
